<script setup>
//  Props
const props = defineProps({
    open: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const hamburger = ref(null);

const { $bus } = useNuxtApp();

$bus.on('close-mobile-menu', () => {
    if (!hamburger.value) return;
    hamburger.value.focus();
});

const label = computed(() => {
    return props.open ? 'Close' : 'More';
});
</script>

<template>
    <button class="hamburger" ref="hamburger">
        <span class="a"></span>
        <span class="b"></span>
        <span class="c"></span>
        <span class="d"></span>
        <span class="more">{{ label }}</span>
    </button>
</template>

<style lang="scss">
.hamburger {
    width: 1.5rem;
    aspect-ratio: 1;
    margin: 1rem;
    position: relative;
    font-size: 13px;
    color: var(--sage);

    span {
        width: 1.5rem;
        height: 2px;
        display: block;
        background: currentColor;
        position: absolute;
        left: 0;
        transition: var(--transition);
        transition-property: top, transform;
        transform-origin: center;

        &.more {
            position: absolute;
            left: calc(-5ch - 1em);
            top: 50%;
            background: transparent;
            width: 5ch;
            height: auto;
            transform: translateY(-50%);
            padding-right: 1em;

            font-size: 13px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            letter-spacing: 1.3px;
            text-transform: uppercase;
        }

        &.a {
            top: 20%;
            transform: translateY(-50%);
        }

        &.b,
        &.c {
            top: 50%;
            transform: translateY(-50%);
        }

        &.d {
            top: 80%;
            transform: translateY(-50%);
        }
    }
}

.showing {
    .hamburger {
        perspective: 50px;
        transform-style: preserve-3d;

        span {

            &.a,
            &.d {
                transform: translateY(-50%) scale(0);
            }

            &.b {
                transform: rotate(-45deg) translateY(-50%);
            }

            &.c {
                top: calc(50% - 1px);
                transform: rotate(45deg) translateY(50%);
            }
        }
    }
}

@media (min-width: 1291px) {
    .hamburger {
        display: none;
    }
}

@media (min-width: $tablet) {
    .hamburger {
        width: 1em;
        height: 1em;
        margin: 2.4rem 1rem;
        margin-left: 8ch;
        transition: 350ms ease-in-out;

        &:hover,
        &:focus {
            color: var(--cream);
        }

        span {
            width: 1em;
            height: 2px;

            &.a {
                top: 15%;
            }

            &.d {
                top: 90%;
            }
        }
    }
}

@media (max-width: $tablet) {
    .hamburger {
        .more {
            display: none;
        }
    }
}
</style>
